import Error404 from '@src/pages/Error404.tsx';
import Error500 from '@src/pages/Error500';
import logger from '@src/utils/logger.ts';
import React, { Component, ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
  isTenant: boolean;
  errorCode?: number;
}

interface ErrorBoundaryState {
  hasError: boolean;
  errorCode: number;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, errorCode: props.errorCode || 500 };
  }

  static getDerivedStateFromError(error: any): ErrorBoundaryState {
    return { hasError: true, errorCode: error.errorCode || 500 };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logger.error('Caught error in ErrorBoundary:', error, info);
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    if (this.state.hasError && this.props.children !== prevProps.children) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      logger.error('Caught error in ErrorBoundary: ', this.state.hasError);
      if (this.state.errorCode === 404) {
        return <Error404 isTenant={this.props.isTenant} />;
      }
      return <Error500 isTenant={this.props.isTenant} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
